import { __ } from '../utils/translation-service';

export function getRatingLabel(rating?: number): string {
    if (rating) {
        if (rating < 3) {
            return __('ugcAverage');
        }
        if (rating < 4.5) {
            return __('ugcOk');
        }
        if (rating < 7) {
            return __('ugcGood');
        }
        if (rating < 8.5) {
            return __('ugcVeryGood');
        }

        return __('ugcExcellent');
    }
    return '';
}
